export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConsultarPage.vue?vue&type=template&id=92dd9f42&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/doctos-oficiales/ConsultarPage.vue?vue&type=template&id=92dd9f42&scoped=true&
// module id = 567
// module chunks = 21